<template lang="pug">
header.v-page-header.page-header(:class="{'page-header--menu-opened': isMenuOpened}")
	.container
		.page-header__layout
			template(v-if="$slots['main_nav']")
				.page-header__main-nav-wrap
					.page-header__main-nav(ref="main-nav")
						slot(name="main_nav")
			template(v-if="$slots['logo']")
				.page-header__cell.page-header__cell--logo
					slot(name="logo")
			.page-header__cell.page-header__cell--menu(v-if="!isSm")
				button.page-header__menu-btn.btn.btn--outline(type="button" @click="toggleMenu")
					v-svg-icon.btn__menu-icon.btn__menu-icon--lines.btn__icon(icon="menu-lines")
					v-svg-icon.btn__menu-icon.btn__menu-icon--cross.btn__icon(icon="menu-cross")
					.btn__text Меню
			//-template(v-if="$slots['picker']")
			//-	.page-header__cell.page-header__cell--logo
			//-		slot(name="picker")
			template(v-if="$slots['search'] && !isSm")
				.page-header__cell.page-header__cell--search
					slot(name="search")
			template(v-if="$slots['bonus'] && !isSm")
				.page-header__cell.page-header__cell--bonus
					slot(name="bonus")
			template(v-if="$slots['delivery_small'] && !isSm")
				.page-header__cell.page-header__cell--delivery-small
					slot(name="delivery_small")
			//-.page-header__cell.page-header__cell--compare
			//-	v-compare-small
			//-.page-header__cell.page-header__cell--basket
			//-	v-basket-small
			.page-header__cell.page-header__cell--favorite(v-if="!isSm")
				v-favorite-small
			.page-header__cell.page-header__cell--btn(v-if="$slots['btn_modal']")
				slot(name="btn_modal")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			menu: [],
			isMenuOpened: false
		};
	},

	mounted() {
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
		controller.events.on('mobile-nav-open', this.openMenu);
		controller.events.on('mobile-nav-close', this.closeMenu);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		toggleMenu() {
			if (this.isMenuOpened) {
				this.closeMenu();
			} else {
				this.openMenu();
			}
		},

		openMenu() {
			controller.lockScrolling(document.querySelector('.page-header__main-nav-wrap'));
			this.isMenuOpened = true;
			document.body.classList.add('state--mob-menu-opened');
		},

		closeMenu() {
			this.isMenuOpened = false;
			document.body.classList.remove('state--mob-menu-opened');
			controller.unlockScrolling(document.querySelectorAll('.page-header__main-nav-wrap'));
		},

		dataSet(data) {
			this.menu.push(data);
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.isMenuOpened) {
				e.stopPropagation();
				this.closeMenu();
			}
		},

		handleClickOutside(e) {
			if (e.target.closest('.page-header__menu-btn')) {
				return;
			}
			if (e.target.closest('.mobile-nav__link')) {
				return;
			}
			if (!this.$refs['main-nav'].contains(e.target) && this.isMenuOpened) {
				e.stopPropagation();
				if (!e.target.closest('.modal') && !e.target.closest('.price__group--second')) {
					this.closeMenu();
				}
			}
		}
	}
};
</script>
